import { NgModule } from "@angular/core";
import { TruncateTextPipe } from "./truncate-text.pipe";
import { RemoveTextPipe } from "./remove-text.pipe";
import { SafeUrlPipe } from "./safe-url.pipe";
import { CommaTextPipe } from "./comma-text.pipe";

@NgModule({
  imports: [
    // dep modules
  ],
  declarations: [TruncateTextPipe, RemoveTextPipe, SafeUrlPipe, CommaTextPipe],
  exports: [TruncateTextPipe, RemoveTextPipe, SafeUrlPipe, CommaTextPipe],
})
export class ApplicationPipesModule {}
